export const RoomMarkerSize = {
  width: 70,
  height: 50,
  pointX: -2,
  pointY: 45,
};

export const PartnerMarkerSize = {
  width: 50,
  height: 50,
  pointX: 25,
  pointY: 47,
};
